import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Container, Label } from './input-sc';
import ErrorMessage from './errorMessage';

const ClassicInput = ({
    errors,
    touched,
    name,
    type,
    label,
    honeyPot,
    className,
    borderColor,
    dynamicValue,
    cleanUpRegex,
    labelColor,
    differentBg,
    textAreaInput,
    isFocused,
    ...props
}) => {
    const [focused, setFocused] = useState(false);

    const {
        initialValues,
        values,
        setFieldValue,
        setFieldTouched,
    } = useFormikContext();

    let value = initialValues[name];
    useEffect(() => {
        if (value || values[name]) {
            setFocused(true);
        }
    });

    useEffect(() => {
        setFieldValue(name, dynamicValue);
    }, [dynamicValue]);

    const processRegex = e => {
        if (cleanUpRegex) {
            setFieldValue(name, e.target.value.replace(cleanUpRegex, ''));
            return;
        }
        setFieldValue(name, e.target.value);
    };

    return (
        <InputWrapper honeyPot={honeyPot} className={className}>
            <Container
                borderColor={borderColor}
                onFocus={() => setFocused(true)}
                focused={focused}
            >
                <Label
                    differentBg={differentBg}
                    labelColor={labelColor}
                    htmlFor={name + '_label'}
                    onClick={() => setFocused(true)}
                    focused={focused}
                >
                    {label}
                </Label>

                {textAreaInput ? (
                    <textarea
                        autoFocus={isFocused}
                        name={name}
                        id={name + '_label'}
                        onFocus={() => setFocused(true)}
                        value={values[name]}
                        onChange={processRegex}
                        onBlur={() => setFieldTouched(name, true, false)}
                        cols="40"
                        rows="5"
                        {...props}
                    ></textarea>
                ) : (
                    <input
                        autoFocus={isFocused}
                        id={name + '_label'}
                        name={name}
                        onFocus={() => setFocused(true)}
                        value={values[name]}
                        onChange={processRegex}
                        onBlur={() => setFieldTouched(name, true, false)}
                        type={type ? type : ''}
                        {...props}
                    />
                )}
            </Container>

            <ErrorMessage show={errors[name]}>{errors[name]}</ErrorMessage>
        </InputWrapper>
    );
};

const InputWrapper = styled.div`
    display: ${({ honeyPot }) => (honeyPot ? 'none' : 'block')};
`;

export default ClassicInput;
